function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AddOrUpdate from './templatemessage-add-and-update';
import * as api from '@/api/templatemessage.js';
import * as roleApi from '@/api/tenant';
export default {
  dicts: [],
  data: function data() {
    return {
      tenantId: '',
      dataForm: {
        type: '',
        name: '',
        content: '',
        freightTemplateId: '',
        status: ''
      },
      selectedTenant: false,
      rangeDataForm: {},
      // 新增排序相关状态
      sortColumn: '',
      // 排序字段（驼峰格式）
      order: '',
      // 排序方式：asc/desc
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      listData: []
    };
  },
  components: {
    AddOrUpdate: AddOrUpdate
  },
  watch: {
    // 监听路由变化（路径/参数/查询都触发）
    $route: {
      handler: function handler() {
        var tenantId = this.$route.query.tenantId;
        if (!tenantId) {
          this.handlerSearch();
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    roleApi.getRoleList({
      page: 1,
      limit: 9999
    }).then(function (data) {
      _this.listData = data.list;
      _this.handlerSearch();
    });
  },
  methods: {
    // ========== 新增方法1：解析映射JSON（仅新增） ==========
    getMarkText: function getMarkText(mark) {
      var map = {
        paySuccess: '支付成功',
        deliver: '发货通知',
        fulfillment: '配送'
      };
      return map[mark] || '未配置';
    },
    getFullMarkFields: function getFullMarkFields(mark) {
      var markFieldConfig = {
        paySuccess: [{
          key: 'orderId',
          label: '订单编号'
        }, {
          key: 'amount',
          label: '支付金额'
        }, {
          key: 'payTime',
          label: '支付时间'
        }],
        deliver: [{
          key: 'orderId',
          label: '订单编号'
        }, {
          key: 'expressName',
          label: '快递公司'
        }, {
          key: 'expressNo',
          label: '快递单号'
        }, {
          key: 'deliverTime',
          label: '发货时间'
        }],
        fulfillment: [{
          key: 'orderId',
          label: '订单编号'
        }, {
          key: 'deliveryPerson',
          label: '配送人'
        }, {
          key: 'deliveryPhone',
          label: '配送电话'
        }, {
          key: 'deliveryTime',
          label: '配送时间'
        }]
      };
      return markFieldConfig[mark] || [];
    },
    // ========== 优化：根据字段key获取映射值 ==========
    getMappingValue: function getMappingValue(jsonStr, key) {
      try {
        var mappingObj = JSON.parse(jsonStr) || {};
        return mappingObj[key] || '';
      } catch (e) {
        return '';
      }
    },
    addOrUpdateHandle: function addOrUpdateHandle(id) {
      var _this2 = this;
      this.addOrUpdateVisible = true;
      this.$nextTick(function () {
        _this2.$refs.addOrUpdate.init(id);
      });
    },
    getDictLabel: function getDictLabel(dictType, dictValue) {
      var dictList = this.dict.type[dictType] || [];
      var item = dictList.find(function (d) {
        return d.value == dictValue;
      });
      return item ? item.label : dictValue;
    },
    getDictLabels: function getDictLabels(dictType, dictValues) {
      if (!dictType || !dictValues) return dictValues;
      var dictList = this.dict.type[dictType] || [];
      var values = typeof dictValues === 'string' ? dictValues.split(',') : dictValues;
      return values.map(function (v) {
        var item = dictList.find(function (d) {
          return d.value == v;
        });
        return item ? item.label : v;
      }).join('，');
    },
    change: function change() {
      console.log(this.tenantId);
      // 如需无历史记录（替换当前 URL），用 replace：
      this.$router.replace({
        path: this.$route.path,
        query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
          tenantId: this.tenantId
        })
      });
      this.handlerSearch();
    },
    handlerSearch: function handlerSearch() {
      this.pageIndex = 1;
      this.tenantId = '';
      var tenantId = this.$route.query.tenantId;
      if (!tenantId) {
        this.selectedTenant = false;
        return;
      }
      this.selectedTenant = true;
      this.tenantId = parseInt(tenantId);
      this.getDataList();
    },
    /**
     * 处理排序变化事件
     * @param {Object} param 排序参数 {prop: 字段名, order: 排序方式}
     */
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      if (order) {
        this.sortColumn = this.camelToUnderline(prop); // 驼峰格式的字段名
        this.order = order === 'ascending' ? 'asc' : 'desc'; // 转换为后端需要的格式
      } else {
        // 取消排序
        this.sortColumn = '';
        this.order = '';
      }
      this.pageIndex = 1; // 排序切换后重置页码
      this.getDataList(); // 重新获取数据
    },
    // 驼峰转下划线的工具函数（核心）
    camelToUnderline: function camelToUnderline(str) {
      // 处理空值，避免报错
      if (!str) return '';
      // 1. 匹配大写字母，在前面加下划线 2. 全部转为小写 3. 去除开头可能多余的下划线
      return str.replace(/[A-Z]/g, function (match) {
        return "_".concat(match.toLowerCase());
      }).replace(/^_/, '');
    },
    /**
     * 处理单个字段的范围搜索
     * @param {String} field 字段名
     */
    handleSingleRangeChange: function handleSingleRangeChange(field) {
      var rangeValue = this.rangeDataForm["".concat(field, "_range")];
      if (Array.isArray(rangeValue) && rangeValue.length === 2) {
        this.dataForm[field] = {
          queryStart: rangeValue[0],
          queryEnd: rangeValue[1]
        };
      } else {
        this.dataForm[field] = {
          queryStart: null,
          queryEnd: null
        };
      }
    },
    search: function search() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList: function getDataList() {
      var _this3 = this;
      this.dataListLoading = true;
      var queryParams = _objectSpread({}, this.dataForm);

      // 添加排序参数到请求参数中
      if (this.sortColumn) {
        queryParams.sortColumn = this.sortColumn;
        queryParams.order = this.order;
      }
      queryParams.tenantId = this.tenantId;
      console.log('搜索参数:', queryParams); // 调试用

      api.templatemessageListApi(_objectSpread(_objectSpread({}, queryParams), {}, {
        page: this.pageIndex,
        limit: this.pageSize
      })).then(function (res) {
        _this3.dataListLoading = false;
        _this3.total = res.total;
        _this3.dataList = res.list;
      }).catch(function () {
        _this3.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle: function sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    resetQuery: function resetQuery() {
      this.pageIndex = 1;

      // 重置表单数据
      this.dataForm = {
        type: '',
        name: '',
        content: '',
        freightTemplateId: '',
        status: ''
      };

      // 重置所有范围选择器

      // 重置排序状态
      this.sortColumn = '';
      this.order = '';
      this.$refs['queryForm'].resetFields();
      this.getDataList();
    },
    // 当前页
    currentChangeHandle: function currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandle: function selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 新增 / 修改
    sync: function sync() {
      var _this4 = this;
      this.$confirm("\u786E\u8BA4\u540C\u6B65\u5417?", '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        api.syncSubscribeMessageTemplate(_this4.tenantId).then(function (res) {
          _this4.$message.success('同步成功！');
          _this4.resetQuery();
        });
      });
    },
    // 删除
    deleteHandle: function deleteHandle(id) {
      var _this5 = this;
      this.$confirm("\u786E\u8BA4\u5220\u9664\u5417?", '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        api.templatemessageDeleteApi({
          id: id // 保持小写id，与参考示例完全一致
        }).then(function (res) {
          _this5.$message.success('删除成功！');
          _this5.resetQuery();
        });
      });
    }
  }
};